export default "__VITE_ASSET__D3bU3U95__"